import { useEffect, useRef } from 'react';
import { isSameYear, isThisYear } from 'date-fns';
import { useCalendar } from '../../Context';
import { YearButton } from '../../styled';
import { isYearDisabled } from '../../utils';
export function Year(props) {
    const ref = useRef(null);
    const { date } = props;
    const { timeZone, locale, focusedDate, selectYear, focusedYear, min, max } = useCalendar();
    const isSelected = isSameYear(date, focusedDate);
    const shouldFocus = isSameYear(date, focusedYear);
    const yearFormat = new window.Intl.DateTimeFormat(locale, { year: 'numeric', timeZone });
    const disabled = isYearDisabled({ date, min, max });
    const handleClick = (event) => {
        event.stopPropagation(); // If used inside ContextDropdown: Prevent it from closing
        selectYear(date);
    };
    useEffect(() => {
        if (ref.current && shouldFocus) {
            ref.current.focus();
            // Place the selected year in the center of the calendar instead of the bottom
            ref.current.scrollIntoView({ block: 'center' });
        }
    }, [ref, shouldFocus]);
    return (<YearButton $isSelected={isSelected} onClick={handleClick} disabled={disabled} ref={ref} tabIndex={isSelected ? 0 : -1} $isThisYear={isThisYear(date)}>
      {yearFormat.format(date)}
    </YearButton>);
}
